import styles from './App.module.css';
import Block from './Block';

// TODO: Check display on different devices
function App() {
  return (
    <div className={styles.container}>
      <div className={styles.app}>
        <div className={styles.spinner}>
          <Block id="head" images={["head/bare.png", "head/ebc.png", "head/green.png", "head/santa.png", "head/sombrero.png", "head/sunglasses.png", "head/trilby.png", "head/mary.png"]} height={157}/>
          <Block id="torso" images={["torso/christmas.png", "torso/dj.png", "torso/green.png", "torso/hawaiian.png", "torso/hoody.png", /*"torso/onesie.png",*/ "torso/santa.png", "torso/starwars.png"]} height={181} />
          <Block id="legs" images={["legs/black.png", "legs/christmas.png", "legs/flares.png", "legs/green.png", "legs/harlequin.png", "legs/jeans.png", /*"legs/onesie.png",*/ "legs/shorts.png"]} height={363} />
        </div>
        <div className={styles.message}>
          <h1>Merry Christmas!</h1>
          <div className={styles.poem}>
            <p>
              'Twas the party before Christmas,
              but what should I wear?!<br />
              To make festive revellers,
              stop still and stare.
            </p>
            <p>
              A hat from my travels,
              some shorts from the pool;<br />
              A Star Wars Christmas jumper,
              to make me look cool?
            </p>
            <p>
              With so many options,
              I struggled to choose.<br />
              So I thought "I'll ask my friends",
              what have I got to lose...
            </p>
          </div>
          <p>We hope you have a fantastic Christmas, and the merriest of New Years,<br />James and Mary</p>
        </div>
      </div>

      <div className={styles.previous}>
        <p>A Baker-Beton Production. See <a href="http://xmas.thewonkywoggle.uk">previous years</a>.</p>
      </div>
    </div>
  );
}

export default App;
